import React, { SVGProps } from 'react'
export const ReturnSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M45.691 24.076c-9.153 2.947-16.267 3.313-22.166 2.522-3.44-.461-6.539-1.322-9.492-2.38l9.795-4.596a4 4 0 1 0-3.398-7.242L5.437 19.414a6.667 6.667 0 0 0-3.29 8.677l6.976 16.162a4 4 0 0 0 7.345-3.17L12.634 32.2c2.984 1 6.237 1.846 9.828 2.327 7.177.962 15.493.444 25.681-2.837 1.221-.393 2.918-.537 4.142-.112.535.186.93.459 1.233.85.309.397.698 1.144.851 2.548.252 2.307-.683 3.881-2.313 5.158-1.776 1.391-4.162 2.189-5.77 2.445l-.247.04-.24.07c-2.315.674-8.19 1.682-15.387 1.172a4 4 0 1 0-.566 7.98c7.905.56 14.6-.469 17.952-1.404 2.555-.445 6.178-1.645 9.191-4.005 3.26-2.553 5.953-6.639 5.333-12.323-.282-2.592-1.108-4.814-2.485-6.588-1.383-1.78-3.144-2.88-4.928-3.5-3.41-1.184-6.992-.662-9.218.055Z"
    />
  </svg>
)
